import { render, staticRenderFns } from "./_username.vue?vue&type=template&id=2fcb99ac&scoped=true&"
import script from "./_username.vue?vue&type=script&lang=js&"
export * from "./_username.vue?vue&type=script&lang=js&"
import style0 from "./_username.vue?vue&type=style&index=0&id=2fcb99ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcb99ac",
  null
  
)

export default component.exports